export function SAVE_CATEGORY(state, [category]){
    state.category = category
}

export function SAVE_DEPARTMENT(state, [department]){
    state.department = department
}

export function SAVE_REWARD_USER_POINTS(state, [reward_user_points]){
    state.reward_user_points = reward_user_points
}

export function SAVE_REWARD_USER_LEVEL(state, [reward_user_level_id, reward_user_level_points]){
    state.reward_user_level_id = reward_user_level_id
    state.reward_user_level_points = reward_user_level_points
}